import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "../Redux/action";
import * as FileSaver from 'file-saver';
import ExcelJS from 'exceljs';
import { toast } from "react-toastify";
import { roomData } from "../Redux/reducer/GetRoomDataReducer";
import moment from "moment";
import nodatafound from '../asset/img/datanotfound_black.png';
import { getHostelReports } from "../Redux/reducer/AttendanceReducer";
import AppDatePicker from "../component/AppDatePicker";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import AppLoader from "../component/AppLoader";
import { getCollegeList, getCourseList, getSchedulerList, getSectionList, getSlotList, getYearList, getdepartmentList, getdepartmentSearch } from "../Redux/reducer/SchedulerReducer";
import { getHostelListSelectSelector, getHostelListSelector } from "../Redux/reducer/HostelReducer";
import { IMAGE_URL } from "../Redux/saga/EndPoints";
import { onboardingData } from "../Redux/reducer/OnboardingList";
export const HostelAttendance = () => {
    const EXCEL_EXTENSION = '.xlsx'
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const dispatch = useDispatch();
    const courseList = useSelector(getCourseList)
    const hostelList = useSelector(getHostelListSelectSelector)
    const collegeList = useSelector(getCollegeList)
    const slotList = useSelector(getSlotList)
    const yearList = useSelector(getYearList)
    const departmentList = useSelector(getdepartmentList)
    const defaultTimeState = {
        start_time: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        end_time: moment()
    };
    const [fromDate, setFromDate] = useState('')
    const [formDetails, setFormDetails] = useState({ ...defaultTimeState })
    const sectionList = useSelector(getdepartmentSearch);
    const [toDate, setToDate] = useState('')
    const [room, setRoom] = useState('')
    const [status, setStatus] = useState('')
    const [err, setErr] = useState({})
    const [viewReports, setViewReport] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const roomList = useSelector(roomData)
    const reportList = useSelector(getHostelReports)
    const [fromTimeValue, onChangeFromTimeValue] = useState('');
    const [toTimeValue, onChangeToTimeValue] = useState('');
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const onboardedList = useSelector(onboardingData);

    useEffect(() => {
        dispatch(Actions.clearReports())
        // dispatch(Actions.clearRooms())

        const callback = () => {
            setLoading(false)
        }
        setLoading(true)
        dispatch(Actions.roomAction("", callback))
        dispatch(Actions.CollegeListAction())
    }, [dispatch])

    const getHostelList = useCallback(() => {
        // let params = {
        //     page: pageNumber
        // }
        dispatch(Actions.hostelListSelect(""))
    }, [dispatch])

    useEffect(() => {
        getHostelList()
    }, [])

    const filterMembers = (input) => {
        if (input) {
            const filtered = onboardedList?.results?.filter(member =>
                member.member_id.toString().toLowerCase().includes(input.toLowerCase()) ||
                member.name.toLowerCase().includes(input.toLowerCase())
            );
            setFilteredMembers(filtered);
        } else {
            setFilteredMembers([]);
        }
    };

    const handleSuggestionClick = (id) => {
        setFormDetails({ ...formDetails, member_id: id });
        setShowSuggestions(false);
    };


    const memberFilterList = (hostel_id) => {
        const callback = (response) => {
            dispatch(Actions.onboardingSearchAction(response));
        };
        let params = {
            hostel_id: hostel_id
        };
        dispatch(Actions.hostellerList(params, callback));
    };

    useEffect(() => {
        if (formDetails?.hostel_id) {
            memberFilterList(formDetails?.hostel_id);
        }
    }, [formDetails?.hostel_id]);

    // useEffect(() => {
    //     const params = {
    //         id: formDetails?.college_id
    //     }
    //     dispatch(Actions.CoursetAction(params))
    // }, [dispatch, formDetails?.college_id])

    // useEffect(() => {
    //     const params = {
    //         id: formDetails?.course_id
    //     }
    //     dispatch(Actions.YearAction(params))
    // }, [dispatch, formDetails?.course_id])

    // useEffect(() => {
    //     const params = {
    //         id: formDetails?.course_id
    //     }
    //     dispatch(Actions.DepartmentAction(params))
    // }, [dispatch, formDetails?.course_id])

    // const getHostelList = useCallback(() => {
    //     setLoading(true)
    //     const callback = (res) => {
    //         setLoading(false)
    //     }
    //     dispatch(Actions.hostelListSelect("", callback))
    // }, [])

    // useEffect(() => {
    //     getHostelList()
    // }, [])

    const clearReport = () => {
        setFromDate("")
        setRoom("")
        setErr("")
        setViewReport("")
        dispatch(Actions.clearReports())
        setFormDetails({ hostel_id: "", member_id: "", subject_type: "", entry_type: "", ...defaultTimeState })
        // dispatch(Actions.clearRooms())

    }
    const viewReport = () => {
        if (!formDetails?.hostel_id) {
            setErr({ "hostel_id": "Please select the hostel" })
        } else if (!fromDate) {
            setErr({ "fromDate": "Please select the Date" })
        }
        // else if (!formDetails?.start_time) {
        //     setErr({ "hostel_id": "Please select the start_time" })
        // } else if (!formDetails?.end_time) {
        //     setErr({ "hostel_id": "Please select the end_time" })
        // } 
        else {
            const callback = (response) => {
                if (response?.status_code === 0) {
                    if (response?.response?.length > 0) {
                        setViewReport(true)
                    } else {
                        toast.error("No report found")
                    }
                    setLoading(false)
                    setErr("")
                }
                else {
                    toast.error(response?.message)
                    setLoading(false)
                }
            }
            let st_time = safeFormatDate(fromDate, 'YYYY-MM-DD', moment().format('YYYY-MM-DD'));
            const params = {
                date: st_time,
                hostel_id: formDetails?.hostel_id,
                start_time: safeFormatDate(formDetails?.start_time, 'HH:mm:ss', '00:00:00'),
                end_time: safeFormatDate(formDetails?.end_time, 'HH:mm:ss', '23:59:59'),
                entry_type: formDetails?.entry_type,
                subject_type: formDetails?.subject_type
            }
            if (formDetails?.member_id) {
                params.member_id = formDetails?.member_id
            }
            setLoading(true)
            dispatch(Actions.hostelAttendanceAction(params, callback))
        }
    }

    const getHostelName = () => hostelList?.find((h) => h?.id == formDetails?.hostel_id)?.name || 'Hostel';
    const getEntryTypeLabel = (v) => (v === 'EN' ? 'Entry' : v === 'EX' ? 'Exit' : 'All');
    const getSubjectTypeLabel = (v) => (v === '2' || v === 2 ? 'Students' : v === '0' || v === 0 ? 'Others' : 'All');
    const safeFormatDate = (val, formatStr, fallback = '-') => {
        if (val == null || val === '') return fallback;
        const m = moment(val);
        return m.isValid() ? m.format(formatStr) : fallback;
    };
    const getFilterSummaryText = () => {
        const parts = [];
        if (fromDate) parts.push(`Date: ${safeFormatDate(fromDate, 'DD-MM-YYYY')}`);
        if (formDetails?.start_time != null && formDetails?.end_time != null)
            parts.push(`Time: ${safeFormatDate(formDetails.start_time, 'HH:mm')} - ${safeFormatDate(formDetails.end_time, 'HH:mm')}`);
        parts.push(`Entry Type: ${getEntryTypeLabel(formDetails?.entry_type)}`);
        parts.push(`Subject Type: ${getSubjectTypeLabel(formDetails?.subject_type)}`);
        if (formDetails?.member_id) parts.push(`Member: ${formDetails.member_id}`);
        else parts.push('Member: All');
        return parts.join(' | ');
    };

    const handleDownload = () => {
        const callback = async (response) => {
            if (response?.status_code !== 0) {
                toast.error("Something went wrong");
                setLoading(false);
                return;
            }
            const reportData = response?.response || [];
            const hostelName = getHostelName();
            const filterSummary = getFilterSummaryText();
            const dateStr = safeFormatDate(fromDate, 'DD-MM-YYYY', moment().format('DD-MM-YYYY'));
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('data', { views: [{ rightToLeft: false }] });
            const colCount = 8;
            worksheet.mergeCells(1, 1, 1, colCount);
            worksheet.getCell(1, 1).value = hostelName;
            worksheet.getCell(1, 1).font = { bold: true };
            worksheet.getCell(1, 1).alignment = { horizontal: 'center', vertical: 'middle' };
            worksheet.mergeCells(2, 1, 2, colCount);
            worksheet.getCell(2, 1).value = filterSummary;
            worksheet.getCell(2, 1).font = { bold: true };
            worksheet.getCell(2, 1).alignment = { horizontal: 'center', vertical: 'middle' };
            const headers = ['S.No', 'Name', 'Member ID', 'Date', 'Time', 'Entry/Exit', 'Room', 'Subject'];
            worksheet.addRow(headers);
            const headerRow = worksheet.getRow(3);
            headers.forEach((_, i) => {
                headerRow.getCell(i + 1).font = { bold: true };
                headerRow.getCell(i + 1).alignment = { horizontal: 'center', vertical: 'middle' };
            });
            reportData.forEach((row, idx) => {
                worksheet.addRow([
                    idx + 1,
                    row.name ?? '',
                    row.member_id ?? '',
                    row.date ?? '',
                    row.time ?? 'Not available',
                    row.entry ?? '',
                    row.room ?? '',
                    row.subject_type == 2 ? 'Student' : (row.subject_type == 4 ? 'Supervisor' : 'Other'),
                ]);
            });
            worksheet.columns = [{ width: 6 }, { width: 22 }, { width: 14 }, { width: 12 }, { width: 14 }, { width: 12 }, { width: 14 }, { width: 12 }];
            const buffer = await workbook.xlsx.writeBuffer();
            const fileName = `student in and out_${dateStr}${EXCEL_EXTENSION}`;
            FileSaver.saveAs(new Blob([buffer], { type: EXCEL_TYPE }), fileName);
            toast.success("Downloaded Successfully");
            setLoading(false);
        };
        const st_time = safeFormatDate(fromDate, 'YYYY-MM-DD', moment().format('YYYY-MM-DD'));
        const params = {
            date: st_time,
            hostel_id: formDetails?.hostel_id,
            start_time: safeFormatDate(formDetails?.start_time, 'HH:mm:ss', '00:00:00'),
            end_time: safeFormatDate(formDetails?.end_time, 'HH:mm:ss', '23:59:59'),
            entry_type: formDetails?.entry_type,
            subject_type: formDetails?.subject_type,
        };
        if (formDetails?.member_id) params.member_id = formDetails?.member_id;
        if (fromDate !== '') {
            setLoading(true);
            dispatch(Actions.hostelAttendanceAction(params, callback));
        }
    };
    const getDefaultTimesForDate = (date) => {
        if (!date) return defaultTimeState;
        const isToday = moment(date).isSame(moment(), 'day');
        return {
            start_time: moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
            end_time: isToday ? moment() : moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
        };
    };
    const handleDateSelect = (selected) => {
        setFromDate(selected);
        setFormDetails((prev) => ({ ...prev, ...getDefaultTimesForDate(selected) }));
        setViewReport(false);
        setErr("");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDetails((prevState) => ({
            ...prevState,
            [name]: value
        }));
        if (name === 'member_id') {
            filterMembers(value);
            setShowSuggestions(true);
        }
    }
    const handleHostelSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'hostel_id': parseInt(selected) })
        setErr({ ...err, "hostel_id": "" })
        memberFilterList(parseInt(selected));
    };

    const handleEntryTypeSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'entry_type': selected })
        setErr({ ...err, "entry_type": "" })
    };

    const handleSubjectTypeSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'subject_type': parseInt(selected) })
        setErr({ ...err, "subject_type": "" })
    };

    const handleTimeChange = (value, time) => {
        if (value) {
            if (time === "start_time") {
                setFormDetails({ ...formDetails, [time]: value })
            } else {
                setFormDetails({ ...formDetails, [time]: value })
            }
        }
    }

    const disabledEndMinutes = (selectedHour) => {
        const startMinute = formDetails?.start_time ? moment(formDetails.start_time).minute() : 0;
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        if (selectedHour === startHour) {
            let minutes = [];
            for (let i = 0; i < startMinute; i++) {
                minutes.push(i);
            }
            return minutes;
        }
        return [];
    }

    const disabledEndHours = () => {
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        let hours = [];
        for (let i = 0; i < startHour; i++) {
            hours.push(i);
        }
        return hours;
    }

    return (
        <>
            {
                isLoading && <AppLoader />
            }
            <div className="ecommerce-widget">
                <h5 className="card-header">Student In / Out Report</h5>
                <div className="card border-3 border-top border-top-primary">
                    <div className="row m-0">
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Hostel <span className="text-danger">*</span></label>
                            <select value={formDetails?.hostel_id} onChange={(e) => handleHostelSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Hostel</option>
                                {Array.isArray(hostelList) && hostelList?.map((o) => {
                                    return <option value={o?.id}>{o?.name}</option>
                                })
                                }
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.hostel_id}</p>
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Date <span className="text-danger">*</span></label>
                            <div className="input-group mb">
                                <AppDatePicker
                                    disabled={!formDetails?.hostel_id}
                                    selected={fromDate && moment(fromDate).isValid() ? moment(fromDate).toDate() : null}
                                    placeholder="Date"
                                    maxDate={new Date()}
                                    onChange={(date) => {
                                        handleDateSelect(date)
                                    }}
                                    notValidTime={true}
                                    id='FormDatePicker'
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.fromDate}</p>
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Start Time</label>
                            <div className="input-group mb">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} onChange={(v) => handleTimeChange(v, "start_time")} value={formDetails?.start_time ?? defaultTimeState.start_time} disableClock={true} className="form-control  cursor-pointer" />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.hostel}</p> */}
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">End Time</label>
                            <div className="input-group mb">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} clearIcon={false} onChange={(v) => handleTimeChange(v, "end_time")} value={formDetails?.end_time ?? defaultTimeState.end_time} disableClock={true} className="form-control dateInput cursor-pointer" disabledHours={disabledEndHours}
                                    disabledMinutes={disabledEndMinutes} />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.end_time}</p> */}
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Entry Type </label>
                            <select value={formDetails?.entry_type} onChange={(e) => handleEntryTypeSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Type</option>
                                <option value={"EN"}>Entry</option>
                                <option value={"EX"}>Exit</option>
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.entry_type}</p>
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Subject Type </label>
                            <select value={formDetails?.subject_type} onChange={(e) => handleSubjectTypeSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Type</option>
                                <option value={"2"}>Students</option>
                                <option value={"0"}>others</option>
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.subject_type}</p>
                        </div>

                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <div className="mb-3 position-relative">
                                <label htmlFor="exampleInputEmail1" className="form-label">Student Name/Id</label>
                                <input value={formDetails?.member_id} name='member_id' disabled={!formDetails?.hostel_id} onChange={handleChange} type="text" className="form-control" id="exampleInputEmail1"
                                    placeholder='Type here' />

                                {showSuggestions && filteredMembers?.length > 0 && (
                                    <div className="dropdown dropdown-position1">
                                        {filteredMembers?.map((member, index) => (
                                            <div key={index} className="dropdown-item" onClick={() => handleSuggestionClick(member?.member_id)}>
                                                <img src={IMAGE_URL + member.img_url} alt="search" style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                                                {member?.name}, {member?.member_id}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate1">
                            {!viewReports ? <button type="button" className="btn btn-primary" onClick={() => viewReport()}>View</button>
                                : <button type="button"
                                    className="btn btn-primary" onClick={() => handleDownload()}>Download</button>}
                            &nbsp;
                            {(fromDate || reportList?.length > 0) && <button className="btn btn-primary" onClick={() => clearReport()}>Clear</button>}
                        </div>
                    </div>

                </div>
                {viewReports && (
                  <>
                    <div className="card mb-3">
                      <div className="card-body py-3">
                        <h6 className="mb-2 text-muted">Selected filter</h6>
                        <div className="d-flex flex-wrap gap-3 align-items-center">
                          <span><strong>Hostel:</strong> {getHostelName()}</span>
                          <span><strong>Date:</strong> {safeFormatDate(fromDate, 'DD-MM-YYYY')}</span>
                          <span><strong>Time:</strong> {formDetails?.start_time != null && formDetails?.end_time != null ? `${safeFormatDate(formDetails.start_time, 'HH:mm')} - ${safeFormatDate(formDetails.end_time, 'HH:mm')}` : '-'}</span>
                          <span><strong>Entry Type:</strong> {getEntryTypeLabel(formDetails?.entry_type)}</span>
                          <span><strong>Subject Type:</strong> {getSubjectTypeLabel(formDetails?.subject_type)}</span>
                          <span><strong>Member:</strong> {formDetails?.member_id || 'All'}</span>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                    <div className="card-body p-0">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive">
                                    {/* {
                                        (Array.isArray(reportList)) && <h4 className="mt-2 p-2">Presents-{Presentees?.length}</h4>
                                    } */}
                                    {(Array.isArray(reportList) && reportList?.length > 0) &&
                                        <table className="table onboardTable">
                                            <thead className="bg-light">
                                                <tr className="border-0">
                                                    <th className="border-0">S.No</th>
                                                    <th className="border-0">Name</th>
                                                    <th className="border-0">Date</th>
                                                    <th className="border-0">Time</th>
                                                    <th className="border-0">Entry/Exit</th>
                                                    <th className="border-0">Room</th>
                                                    <th className="border-0">Subject</th>
                                                    {/* <th className="border-0">Access Type</th> */}

                                                    {/* <th className="border-0">Remarks</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(reportList) && reportList?.length > 0) && reportList?.map((item, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.name} ({item?.member_id})</td>
                                                        <td>{item?.date}</td>
                                                        <td>{item?.time ? item?.time : "Not available"}</td>
                                                        <td>{item?.entry}</td>
                                                        <td>{item?.room}</td>
                                                        <td>
                                                            {item?.subject_type == 2
                                                                ? "Student"
                                                                : (item?.subject_type == 4)
                                                                    ? "Supervisor"
                                                                    : "Other"}
                                                        </td>

                                                        {/* <td>{item?.attendance_type}</td> */}
                                                    </tr>
                                                })}

                                            </tbody>
                                        </table>}
                                    {reportList?.length === 0 && <div className="d-flex justify-content-center mt-5">
                                        <div className="NodataFound mb-3">
                                            <h3>No Data Found</h3>
                                        </div>
                                        <div className="NodataImage">
                                            <img src={nodatafound} alt="No Data Found" className="NoData" />
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                  </>
                )}
            </div>
        </>
    )
}